import { useEffect, useState } from "react";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _AdquisitionItem } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { SelectModalityNewSer } from "../../../../../contract/select/SelectModalityNewSer";

interface ProcedureFunctions {
    _procedure: any;
    _pocessData?: any;
    _exportMap: Function;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const PC001 = ({ configProcedure }: Props) => {

    const { instance: instanceItem, bean: beanItem, setBean: setBeanItem } = useDataBean(_AdquisitionItem);

    const [props, setProps] = useState<any>({});
    const [bean, setBean] = useState<any>({});

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData]);

    useEffect(() => {
        if (props?.IDAdquisitionItem) {
            instanceItem.getAdquisitionItem(props?.IDAdquisitionItem).then(
                (resp) => {
                    setBeanItem(resp);
                    if (resp.IDHiringModality) {
                        setBean({ ...bean, IDHiringModality: resp.IDHiringModality })
                    }
                }
            ).catch(err => { toast.error(err) })
        }
    }, [props?.IDAdquisitionItem])

    const onExportMap = () => {
        if (beanItem.IDHiringModality != bean.IDHiringModality) {
            instanceItem.updateAdquisitionItem({ ...beanItem, IDHiringModality: bean.IDHiringModality }).then(
                (resp) => {
                    configProcedure?._pushInfo?.(`Se selecciono la modalidad ${resp.DataBeanProperties.ModalityName}`)
                    configProcedure?._pushProps?.({ IDHiringModality: resp.DataBeanProperties.IDHiringModality, NotModifyHiringModality: true });
                    configProcedure?._exportMap?.(resp.DataBeanProperties);
                }
            ).catch((err) => {
                toast.error("No se pudo realizar la acción");
                console.error(err);
            })
        } else {
            configProcedure?._pushInfo?.(`Se selecciono la modalidad ${beanItem.ModalityName}`)
            configProcedure?._pushProps?.({ IDHiringModality: bean.IDHiringModality, NotModifyHiringModality: true });
            configProcedure?._exportMap?.(bean);
        }
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <SelectModalityNewSer idSelector={bean.IDHiringModality} onChange={(e) => { setBean({ ...bean, "IDHiringModality": e }) }} />
            </div>
            <div className="col-md-12">
                <BasicButton useMargin eventClick={() => {
                    if (bean.IDHiringModality) {
                        onExportMap()
                    } else {
                        toast.error("Debe seleccionar una Modalidad de Contratación")
                    }
                }} icon="ri-send-plane-line" >Seleccionar</BasicButton>
            </div>
        </div>
    )
}